var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-container"},[_c('Paginate',{attrs:{"initial-page":_vm.currentPage,"page-count":_vm.totalPages,"click-handler":_vm.handleCurrentChange,"prev-text":"이전","next-text":"다음","break-view-class":"break-view"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }